<template>
  <div class="container mt-4">
    <h2 class="text-center mb-4">网格性能分析结果</h2>
    <div v-for="server in sortedServers" :key="server.name" class="mb-5">
      <h3>{{ server.name }}</h3>
      <h5>网格本身耗时</h5>
      <div class="table-responsive">
        <table class="table table-dark table-striped">
          <thead>
            <tr>
              <th>统计时间</th>
              <th>网格名称</th>
              <th>总耗时 (毫秒)</th>
              <th>帧耗时 (毫秒)</th>
              <th>是否造成延迟</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="profile in server.profiles.grid" :key="profile.ID" :class="{'bg-light-red': profile.CausesLag}">
              <td>
                {{ fmtDate(profile.Time) }}
                ({{ timeAgo(profile.Time) }})
              </td>
              <td>{{ profile.GridName }}</td>
              <td>{{ profile.TotalTime }}</td>
              <td>{{ profile.FrameTime }}</td>
              <td>{{ profile.CausesLag ? '是' : '否' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h5>物理耗时最高区域</h5>

      <div class="physic-grid-panel panel">
        <div><span class="physic-item-title">导致卡顿:</span> {{ server.profiles.physic.CausesLag ? '是' : '否' }}<small class="text-red" v-if="server.profiles.physic.CausesLag"> (当模拟率低时, 这代表这个区域的其中一个网格造成物理卡服) </small></div>
        <div><span class="physic-item-title">统计时间:</span> {{ fmtDate(server.profiles.physic.Time) }} ({{ timeAgo(server.profiles.physic.Time) }})</div>
        <div><span class="physic-item-title">区域物理总耗时:</span>{{ server.profiles.physic.TotalTime }} ms</div>
        
        <span class="physic-item-title">区域内网格: </span>
        <div :class="{'text-red':server.profiles.physic.CausesLag, 'physic-grid-panel-grid': true}" v-for="grid in server.profiles.physic.Grids" :key="grid.ID">
          {{ grid.GridName }}
          [{{ grid.Ownership }}]
          <!-- <td>{{ server.profiles.TotalTime }}</td> -->
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from '../api/axios';
import { formatDate, timeAgo } from '../util/time';

export default {
  data() {
    return {
      gridProfiles: [],
      physicProfiles: [],
      groupedGridProfiles: {}
    };
  },
  methods: {
  timeAgo: timeAgo,
  fmtDate: formatDate,
  fetchGridProfiles() {
    Promise.all([
      axios.get('/profile/grid'),
      axios.get('/profile/physic')
    ])
    .then(responses => {
      // Assume responses[0].data and responses[1].data are arrays of grid and physic profiles respectively
      const gridProfiles = responses[0].data;
      const physicProfiles = responses[1].data;
      
      // Merge and group data
      this.groupedGridProfiles = {};

      // Group grid profiles
      gridProfiles.forEach(profile => {
        const server = profile.ServerName;
        if (!this.groupedGridProfiles[server]) {
          this.groupedGridProfiles[server] = { grid: [], physic: [] };
        }
        this.groupedGridProfiles[server].grid.push(profile);
      });

      // Group physic profiles
      physicProfiles.forEach(profile => {
        const server = profile.ServerName;
        if (!this.groupedGridProfiles[server]) {
          this.groupedGridProfiles[server] = { grid: [], physic: [] };
        }
        this.groupedGridProfiles[server].physic=profile;
      });

      // Optionally sort each server's profiles by Total Time in descending order
      Object.keys(this.groupedGridProfiles).forEach(server => {
        this.groupedGridProfiles[server].grid.sort((a, b) => b.TotalTime - a.TotalTime);
      });
      console.log(this.groupedGridProfiles)
    })
    .catch(error => {
      console.error('Error fetching profiles:', error);
    });
  }
},
computed: {
    sortedServers() {
      return Object.keys(this.groupedGridProfiles)
        .sort()
        .map(serverName => ({
          name: serverName,
          profiles: this.groupedGridProfiles[serverName]
        }));
    }
  },

  mounted() {
    this.fetchGridProfiles();
  }
};
</script>
<style scoped>
.bg-light-red td {
  color: rgb(200, 88, 86) !important; /* Pale red background */
}

.physic-grid-panel{
  border: 1px solid #333;
  padding: 15px;
}
.physic-grid-panel-grid{
  padding: 5px;
  display: inline;
  background-color: #00000033;
  border-radius: 7px;
  margin-right: 5px;
}
.text-red {
  color: rgb(200, 88, 86)
}

.physic-item-title{
  color: #CCCCCC;
  font-size: 0.9em;
  margin-right: 10px;
}
</style>
